import request from '../network';


export function askToBotService({question, agent_id, session_id}: {
    question: string, agent_id?: string, session_id: string
}) {

    const params: { [key: string]: string } = {question, session_id}

    if (agent_id) {
        params.agent_id = agent_id
    }

    return request.POST<{
        success: boolean,
        result: string
    }>(`/api/v1/bot`, params).then(res => res).catch(reason => reason);
}

